import { StoreType, StoreTypeVerticals } from 'models/store-type';
import { RedButtonCity } from './redbutton.actions';

export const SAVE_CHANGES_REDBUTTON = 'SAVE_CHANGES_REDBUTTON';
export const SET_LOADING_REDBUTTON = 'SET_LOADING_REDBUTTON';
export const TOGGLE_ALL = 'TOGGLE_ALL';
export const LOAD_STORE_TYPES = 'LOAD_STORE_TYPES';
export const LOAD_REDBUTTON_CITIES = 'LOAD_REDBUTTON_CITIES';
export const SWITCH_STORE_TYPES = 'SWITCH_STORE_TYPES';
export const SET_VERTICAL = 'SET_VERTICAL';
export const SET_CITY = 'SET_CITY';

interface SetLoadingRedButton {
  type: typeof SET_LOADING_REDBUTTON;
  payload: { loading: boolean };
}

interface SaveChangesRedButton {
  type: typeof SAVE_CHANGES_REDBUTTON;
  payload: { changes: StoreType[] };
}

interface EnableDisableAll {
  type: typeof TOGGLE_ALL;
  payload: {
    changes: StoreType[];
    allEnabled: boolean;
  };
}

interface LoadStoreTypes {
  type: typeof LOAD_STORE_TYPES;
  payload: {
    stVerticals: StoreTypeVerticals;
    allEnabled: boolean;
    vertical?: string;
    changes: StoreType[];
  };
}

interface LoadRedButtonCities {
  type: typeof LOAD_REDBUTTON_CITIES;
  payload: {
    cities?: RedButtonCity[];
    selectedCity?: RedButtonCity;
    loadingCities?: boolean;
  };
}

interface SwitchStoreTypes {
  type: typeof SWITCH_STORE_TYPES;
  payload: { changes: StoreType[] };
}

interface SetSelectedVertical {
  type: typeof SET_VERTICAL;
  payload: { vertical: string; changes: StoreType[] };
}

interface SetSelectedCity {
  type: typeof SET_CITY;
  payload: { selectedCity: RedButtonCity };
}

export type RedButtonActions =
  | SaveChangesRedButton
  | SetLoadingRedButton
  | EnableDisableAll
  | LoadStoreTypes
  | SwitchStoreTypes
  | SetSelectedVertical
  | LoadRedButtonCities
  | SetSelectedCity;
